import React, { useEffect } from "react";
import { faq } from "./COPPHA";
import HeaderImage from "../../components/HeaderImage";


const CourseDetailPage: React.FC = () => {

      useEffect(() => {
        const element = document.getElementById("coppha");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, []);

  return (
    <>
         <HeaderImage image="/assets/images/backgrounds/coppha.jpg"   alt="COPPHA Header"
  showButton={true}
  buttonText="Explore"
  buttonLink="https://wacren.net/en/establishing-a-diamond-oa-publishing-ecosystem-for-public-health-research-in-africa-the-coalition-for-open-access-publishing-of-public-health-in-africa-coppha/" />
    <div className="max-w-6xl mx-auto p-4" id="coppha">
      {/* Course Title Section */}
      <section className="mb-16">
        <h2 className="text-lg font-bold text-green-800 mb-6">COPPHA PEER REVIEWING COURSE (2024)</h2>
        <p className="text-sm mb-4">
          The 2024 COPPHA Peer Reviewing Course was delivered by WACREN and Peoples-Praxis, key partners in the Coalition for Open Access Publishing of Public Health in Africa (COPPHA). The course’s primary objective was to train African researchers in all aspects of the peer review process, enabling them to conduct high-quality reviews. Key skills developed through the course included critically assessing research manuscripts, providing constructive and actionable feedback, and upholding ethical standards.
        </p>
        <p className="text-sm mb-6">
          Delivered as a five-week Massive Open Online Course (MOOC) from October 7 to November 10, 2024, the program blended asynchronous learning on the Peoples-Praxis platform with optional live Zoom sessions. The course covered:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-green-700 text-white p-6 rounded-lg text-center text-sm font-semibold shadow-md">
            Fundamentals and Challenges of Peer Review
          </div>
          <div className="border border-green-700 text-green-700 p-6 rounded-lg text-center text-sm font-semibold shadow-md">
            AI and the Review Process
          </div>
          <div className="border border-green-700 text-green-700 p-6 rounded-lg text-center text-sm font-semibold shadow-md">
            How to Review a Journal Article
          </div>
          <div className="bg-green-700 text-white p-6 rounded-lg text-center text-sm font-semibold shadow-md">
            Performing a Peer Review Assignment
          </div>
        </div>
        <p className="text-sm text-gray-700 mt-6 text-center max-w-3xl mx-auto">
          The course concluded with participants completing a peer review assignment, and those who successfully completed the course received a certificate of completion.
        </p>
      </section>

      {/* What Next Section */}
      <section className="mb-16">
        <h3 className="font-bold text-lg text-green-800 mb-6">WHAT NEXT AFTER THE 2024 COPPHA PEER REVIEWING COURSE?</h3>
        <p className="text-sm text-gray-700 mb-6">
          Participants who successfully completed the COPPHA Peer Reviewing Course are eligible to join the upcoming COPPHA Open Publishing Course, scheduled for the first quarter (Q1) of 2025. This course will focus on open publishing principles, with a focus on preprints and open reviews. Participants will engage with a case study, post a preprint on the BAOBAB repository, and complete an open review on the PublishNow platform. The course aims to introduce participants to equitable publishing models that facilitate faster research dissemination and build a community of practice for peer reviewing and innovative publishing in Africa. It is divided into five weekly sections:
        </p>
        <div className="bg-blue-400 py-10 px-6 rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            <div className="bg-white text-green-900 p-6 rounded-lg text-center text-sm font-semibold shadow-md">
              Open Access Publishing (Week 1)
            </div>
            <div className="bg-white text-green-900 p-6 rounded-lg text-center text-sm font-semibold shadow-md">
              Open Reviewing and a Case Study (Week 2)
            </div>
            <div className="bg-white text-green-900 p-6 rounded-lg text-center text-sm font-semibold shadow-md">
              Posting a Preprint (Week 3)
            </div>
            <div className="bg-white text-green-900 p-6 rounded-lg text-center text-sm font-semibold shadow-md">
              Posting an Open Review (Weeks 4 & 5)
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="mb-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-b py-6 text-center">
          <div>
            <h4 className="text-xl font-bold text-green-700">40</h4>
            <p className="text-sm text-gray-700">Countries Represented</p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-green-700">651</h4>
            <p className="text-sm text-gray-700">Course Participants</p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-green-700">70%</h4>
            <p className="text-sm text-gray-700">Early-career Professionals</p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-green-700">203</h4>
            <p className="text-sm text-gray-700">Certificates Issued</p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
        <section className="mb-16">
          <h3 className="text-2xl font-semibold text-center mb-6">Frequently Asked Questions</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {faq.map(({question, answer}, index) => (
              <div key={index} className="bg-gray-100 p-6 rounded-lg text-sm">
                <p className="font-semibold text-foreground">{question}</p>
                <p>{answer}</p>
               </div>
            ))}
          </div>
        </section>
    </div>
    </>

  );
};

export default CourseDetailPage;
